// generated by the plop

import { PaginateQuery, PaginatorModel } from 'symbols';
import { StandFilterModel, StandModel, StandsCountModel, StandStatusExpectBackend } from '../../symbols';

export class UpdatedStandByWS {
  static type = '[standList] UpdatedStandByWS';

  constructor(public stand: StandModel) {
  }
}

export class CreatedStandByWS {
  static type = '[standList] CreatedStandByWS';

  constructor(public stand: StandModel) {
  }
}

export class GetStandList {
  static type = '[standList] GetStandList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<StandFilterModel>) {
  }
}

export class GetStandListSuccess {
  static type = '[standList] GetStandListSuccess';

  constructor(public standList: PaginatorModel<StandModel>, public lazy: boolean) {
  }
}

export class GetStandListError {
  static type = '[standList] GetStandListError';

  constructor(public error: any) {
  }
}

export class GetStandStatusList {
  static type = '[standList] GetStandStatusList';

  constructor() {
  }
}

export class GetStandStatusListSuccess {
  static type = '[standList] GetStandStatusListSuccess';

  constructor(public standStatusList: StandStatusExpectBackend[]) {
  }
}

export class GetStandStatusListError {
  static type = '[standList] GetStandStatusListError';

  constructor(public error: any) {
  }
}

export class ClearScrollPositionStandList {
  static type = '[StandsList] ClearScrollPositionStandList';
}

export class UpdateScrollPositionStandList {
  static type = '[StandsList] UpdateScrollPositionStandList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedStandId {
  static type = '[StandsList] SetLastOpenedStandId';

  constructor(public standId: string) {
  }
}

export class GetStandsCount {
  static type = '[StandsList] GetStandsCount';
}

export class StandsCountWS {
  static type = '[StandsList] StandsCountWS';

  constructor(public standsCount: StandsCountModel) {
  }
}

export class AcceptedStandCountWS {
  static type = '[StandsList] AcceptedStandCountWS';

  constructor(public standsCount: number) {
  }
}


